import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import {
    isPaymentDoneMessage,
    isPaymentReturnOrigin,
    PAYMENT_DONE_MESSAGE,
} from "../lib/cardPayment"

/** Слушает postMessage от api.comfortkino.ru/blank.html после оплаты картой. */
export function usePaymentReturnListener(enabled = true) {
    const navigate = useNavigate()

    useEffect(() => {
        if (!enabled) return

        const onMessage = (event: MessageEvent) => {
            if (!isPaymentReturnOrigin(event.origin)) return
            if (!isPaymentDoneMessage(event.data)) return
            navigate("/tickets")
        }

        window.addEventListener("message", onMessage)
        return () => window.removeEventListener("message", onMessage)
    }, [enabled, navigate])
}

export { PAYMENT_DONE_MESSAGE }
